export const sortByCreatedAt = <T>(a: { created_at: string | null } & T, b: { created_at: string | null } & T) => {
    if(!a.created_at || !b.created_at) return 0
    return new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
}